import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { PieChartSVG } from '@common_components/svg/pieChart.svg';

const PieChartIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <PieChartSVG/>
    </div>
  );
};

export { PieChartIcon };
